export default __webpack_public_path__ + "5931ffd340cb0d323878dbe631d3cfb6.png";